<template>
  <div class="popover-follow-us">
    <img src="../../../../assets/imgs/homepage/GZH-qrcode.jpg" alt="">
    <p class="title">扫码关注公众号</p>
    <p class="desc">获取最新签证资讯</p>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.popover-follow-us {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  >img {
    width: 180px;
    height: 180px;
  }
  .title {
    margin-top: 8px;
    font-size: 16px;
    color: #599FFF;
    line-height: 22px;
  }
  .desc {
    margin-top: 4px;
    font-size: 12px;
    color: #5F666E;
    line-height: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/popover/popover-follow-us.vue